module.exports = __webpack_public_path__ + "media/images/carbon_hospitals/common/hospital_informations/noimage_s1000x500-87f5e03fc475b5c8adcd85fa147e4ec3.png";